import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as ListIcon } from "src/images/list.svg";
import { DropdownMenuItem } from "src/app/components/Dropdown/Dropdown";
import CONSTS from "../../../helpers/consts";

export default function AddToCreatorListDropdownMenuItem({
  selectedInfluencers,
  influencersInList,
  addToAudience,
}) {
  const addToAudienceDisabled =
    (influencersInList?.length ?? 0) + selectedInfluencers.length >
    CONSTS.audienceListUsersLimit;
  return (
    <DropdownMenuItem
      onClick={addToAudience}
      disabled={addToAudienceDisabled}
      data-qa="add-to-creator-list-dropdown-menu-item"
    >
      <ListIcon />
      <IDHFormattedMessage
        id="front_creator_list"
        defaultMessage="Creator list"
      />
    </DropdownMenuItem>
  );
}
